import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { PackagingStrategy } from './work-center'

@Directive({
  selector: '[appPackagingStrategySelect]',
})
export class PackagingStrategySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'packaging.approach.title'
    this.select.displayProperty = 'displayValue'

    this.select.dataSource = enumTranslationService.enumDataSource(
      PackagingStrategy,
      'packaging.approach',
      false
    )
  }
}
